import { ActivitiesEffects } from './activities.effects';
import { AccessSettingsEffects } from '@app/private-office/modules/access-settings/store';
import { UserEffects } from '@app/layout/store';
import {LanguageEffects} from "@app/store/effects/language.effects";

export const rootEffects = [ActivitiesEffects, AccessSettingsEffects, UserEffects, LanguageEffects];
